/* 用户协议 */
<template>
    <div class="user-agreement-box">
        <div class="content">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    }
};
</script>

<style lang="less" scpoed>
.user-agreement-box {
    .content {
        padding: 20px 15px;
        font-size: 14px;
        color: #333333;
    }
}
</style>
